export const eventDateKey = 'eventDate';

export const TASK_HISTORY_SKELETON_ROWS = 6;

export const COLUMN_WIDTH = {
  NAME: '20%',
  STATUS: '12%',
  EVENT_DATE: '22%',
  USER: '18%',
  EVENT_REASON: '28%',
};
